import React from 'react';
import { Newspaper } from 'lucide-react';

const NEWS_ITEMS = [
  {
    image: '/images/npiaj68u_IMG_6898.jpg',
    eyebrow: 'Airport Salute',
    title: '5 Rafale Fighter Jets Inducted into the Indian Air Force',
    summary: 'Bhartiya ARFFVs perform the traditional water-cannon salute as the first Rafale fighter jets are formally inducted into the IAF.',
  },
  {
    image: '/images/ccbe0bio_17177861-f1de-4c6b-a780-7349706c7237.JPG',
    eyebrow: 'Incredible Bharat Now',
    title: "Bharat Panther — India's First Indigenously Developed Crash Fire Tender",
    summary: 'Noida-based Bhartiya Vehicles & Engineering manufactures the BHARAT PANTHER — India\u2019s first indigenously designed and developed Crash Fire Tender for the IAF.',
  },
  {
    image: '/images/3zplv5rl_D96EAA1C-E187-48A9-85DF-EB9BB6AC60D0.jpg',
    eyebrow: 'ANI · Rafale Induction',
    title: 'Welcoming Champions Indian Cricket Team Home',
    summary: 'Bhartiya ARFFVs perform a ceremonial water salute as the victorious Indian Cricket Team arrives at the airport.',
  },
  {
    image: '/images/tk2kcick_38042cdc-2ecc-44e3-8f5c-7c2e8a9fd2f3.JPG',
    eyebrow: 'Hindi Daily · ANI',
    title: 'Air Force Receives First Indigenous Crash Fire Tender',
    summary: 'The Indian Air Force received its first indigenously designed Crash Fire Tender (CFT) under a ₹291 crore contract from a Noida-based MSME — delivered in just 14 months.',
  },
  {
    image: '/images/kfe7v8y0_893d7316-5479-438a-96a6-ab5060c5d3c6.JPG',
    eyebrow: 'Hindi Newspaper Coverage',
    title: 'Air Force Receives First Indigenous Fire Tender',
    summary: 'A Noida-based company was awarded the ₹291 crore contract — first CFT delivered within 14 months, a major boost for Make in India in defence manufacturing.',
  },
  {
    image: '/images/t597s3s2_7fc82aac-a326-4356-8e1f-1fcfe1c45e49.JPG',
    eyebrow: 'Indian Startup News',
    title: 'IAF Receives First Indigenously Designed Crash Fire Tender',
    summary: 'Indian Startup News covers the IAF\u2019s acceptance of the first CFT manufactured by a Noida-based Indian MSME firm — featured on Au-Indian Investment Forum.',
  },
  {
    image: '/images/et5kabih_7fa85903-c8e4-4de2-af95-d7062276ba05.JPG',
    eyebrow: 'Indian Air Force · Official',
    title: '#SelfReliance & #AtmanirbharBharat — IAF Inducts First Indigenous CFT',
    summary: 'Indian Air Force\u2019s official social media post: \u201cThe Indian manufacturer ensured the delivery of the CFT within 14 months of contract signing\u201d — achieved despite global supply-chain disruptions.',
  },
  {
    image: '/images/wrbqrye6_9E34CE96-41EC-48C3-80F2-5671CA006694.jpg',
    eyebrow: 'Film Feature',
    title: 'Fighter 2024 Movie',
    summary: 'Bhartiya\u2019s Rosenbauer ARFFV featured alongside an Indian Air Force pilot in a scene from the 2024 film.',
  },
];

const NewsMedia = () => {
  return (
    <div className="min-h-screen bg-white" data-testid="news-media-page">
      {/* Hero Section */}
      <section className="relative bg-slate-900 text-white py-20 md:py-28 overflow-hidden">
        <div className="absolute inset-0 opacity-[0.08]" style={{
          backgroundImage: 'radial-gradient(circle at 20% 30%, white 1px, transparent 1px), radial-gradient(circle at 80% 70%, white 1px, transparent 1px)',
          backgroundSize: '48px 48px'
        }}></div>
        <div className="absolute left-0 top-0 h-1 w-full bg-red-600"></div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <span className="eyebrow" style={{ color: '#f4a8b4' }}>News & Media</span>
          <h1 className="font-display text-4xl md:text-6xl font-extrabold mb-5 mt-3 text-balance">
            Latest News & Press Releases
          </h1>
          <p className="text-base md:text-lg text-slate-300 max-w-2xl mx-auto">
            Updates, announcements, and media coverage from Bhartiya Vehicles & Engineering Co. Ltd.
          </p>
        </div>
      </section>

      {/* News Grid */}
      <section className="py-24 bg-slate-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {NEWS_ITEMS.map((item, i) => (
              <article
                key={i}
                className="group bg-white border border-slate-200 rounded-md overflow-hidden shadow-sm hover:shadow-xl hover:-translate-y-1 hover:border-slate-300 transition-all duration-300"
                data-testid={`news-card-${i}`}
              >
                <div className="relative bg-slate-100 overflow-hidden flex items-center justify-center h-72">
                  <img
                    src={item.image}
                    alt={item.title}
                    loading="lazy"
                    className="w-full h-full object-contain"
                  />
                </div>
              </article>
            ))}
          </div>

          <div className="text-center mt-16">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-white border border-slate-200 rounded-full text-sm text-slate-500">
              <Newspaper className="h-4 w-4 text-red-600" />
              More stories coming soon
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default NewsMedia;
